import { useTranslation } from 'react-i18next';
import { useDashboardDaysStore } from '@Models/useDashboardDaysModel';

import DashboardLayout from '@Dashboard/Layout/DashboardLayout';
import DashboardTabs from '@Dashboard/Layout/DashboardTabs';
import TimeRangeSelector from '@Dashboard/TimeRangeSelector';
import HighRiskRecipients from './HighRiskRecipients';
import SpamGraymailRecipients from './SpamGraymailRecipients';

const RiskUserRecipient = (props: { insightsData: any }) => {
  const { t } = useTranslation();
  const daysModel = useDashboardDaysStore();

  return (
    <DashboardLayout
      title={t('riskUser.recipient.title')}
      barColor="#42CC79"
      titleBar={<TimeRangeSelector widgetId="RiskUserRecipient" />}
    >
      <DashboardTabs
        column={2}
        tabs={[
          {
            key: 'malicious',
            title: t('riskUser.recipient.malicious'),
            body: () => (
              <HighRiskRecipients
                day={daysModel.days['RiskUserRecipient']}
                insightsData={props?.insightsData || {}}
              />
            ),
          },
          {
            key: 'spammers',
            title: t('riskUser.recipient.spammer'),
            body: () => (
              <SpamGraymailRecipients
                day={daysModel.days['RiskUserRecipient']}
                insightsData={props?.insightsData || {}}
              />
            ),
          },
        ]}
      />
    </DashboardLayout>
  );
};

export default RiskUserRecipient;
